import { List } from "@mui/material";
import { collection, getDocs, query, where } from 'firebase/firestore';
import { db } from '../../config/firebase';
import { useQuery } from "@tanstack/react-query";
import { MyProjectItem } from "../User/Profile/myProjectsItem";
import { LoadingCircle } from "../loading";
import { Typography } from "@mui/material/node";

export const MyProjectsList = (props) => {

    const { data: projects, isLoading, isError } = useQuery({queryKey:["loadmyprojects"], queryFn: async () => {
        const q = query(collection(db, "project"), where("owner", "==", props.user.uid));
        const data = await getDocs(q)

        const filteredData = data.docs.map((doc) => ({
            ...doc.data(),
            id: doc.id
        }));

        return filteredData;
    }});

    if (isLoading) return (<LoadingCircle/>)

    if (isError) return (
        <h1>Ou ... Can't load your projects :(</h1>
    )

    if (!isLoading && !isError && projects.length == 0) return (
        <Typography>No projects yet.</Typography>
    )

    return (
        <List>
            {projects?.map((value) => (
                <MyProjectItem project={value} />
            ))}
        </List>
    );
};